<template>
  <md-toolbar
    id="toolbar"
    md-elevation="0"
    class="md-transparent md-absolute"
    :class="extraNavClasses"
    :color-on-scroll="colorOnScroll"
    v-if="!this.hide">

    <div class="md-toolbar-row md-collapse-lateral">
      <div class="md-toolbar-section-start">
        <router-link :to="{ name: 'index'}"><h3 class="md-title">JODA</h3></router-link>
      </div>
      <div class="md-toolbar-section-end">
        <md-button
          class="md-just-icon md-simple md-toolbar-toggle"
          :class="{ toggled: toggledClass }"
          @click="toggleNavbarMobile()">
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <div class="md-collapse">
          <div class="md-collapse-wrapper">
            <mobile-menu nav-mobile-section-start="false">
              <!-- Here you can add your items from the section-start of your toolbar -->
            </mobile-menu>
            <md-list>
              <li class="md-list-item" v-if="!showDownload">
                <a
                  href="javascript:void(0)"
                  class="md-list-item-router md-list-item-container md-button-clean dropdown">

                  <div class="md-list-item-content">
                    <drop-down direction="down">
                      <md-button
                        slot="title"
                        class="md-button md-button-link md-white md-simple dropdown-toggle"
                        data-toggle="dropdown">
                        <i class="material-icons">apps</i>
                        <p>Components</p>
                      </md-button>
                      <ul class="dropdown-menu dropdown-with-icons">
                        <li>
                          <a href="javascript:void(0)">
                            <i class="material-icons">layers</i>
                            <p>All Components</p>
                          </a>
                        </li>
                        <li>
                          <a
                            href="javascript:void(0)">
                            <i class="material-icons">content_paste</i>
                            <p>Documentation</p>
                          </a>
                        </li>
                      </ul>
                    </drop-down>
                  </div>
                </a>
              </li>

              <md-list-item
                href="javascript:void(0)"
                target="_blank"
                v-if="showDownload">
                <i class="material-icons">content_paste</i>
                <p>Documentation</p>
              </md-list-item>

              <md-list-item
                href="javascript:void(0)"
                @click="scrollToElement()"
                v-if="showDownload">
                <i class="material-icons">cloud_download</i>
                <p>Download</p>
              </md-list-item>

              <li class="md-list-item" v-else>
                <a
                  href="javascript:void(0)"
                  class="md-list-item-router md-list-item-container md-button-clean dropdown">
                  <div class="md-list-item-content">
                    <drop-down direction="down">
                      <md-button
                        slot="title"
                        class="md-button md-button-link md-white md-simple dropdown-toggle"
                        data-toggle="dropdown">
                        <i class="material-icons">view_carousel</i>
                        <p>Examples</p>
                      </md-button>
                      <ul class="dropdown-menu dropdown-with-icons">
                        <li>
                          <a href="#/landing">
                            <i class="material-icons">view_day</i>
                            <p>Landing Page</p>
                          </a>
                        </li>
                        <li>
                          <a href="#/login">
                            <i class="material-icons">fingerprint</i>
                            <p>Login Page</p>
                          </a>
                        </li>
                        <li>
                          <a href="#/profile">
                            <i class="material-icons">account_circle</i>
                            <p>Profile Page</p>
                          </a>
                        </li>
                      </ul>
                    </drop-down>
                  </div>
                </a>
              </li>

              <md-list-item
                href="javascript:void(0)"
                target="_blank">
                <i class="fab fa-line"></i>
                <p class="hidden-lg">Line</p>
                <md-tooltip md-direction="bottom">Contact us on Line Official Account</md-tooltip>
              </md-list-item>
              <md-list-item
                href="javascript:void(0)"
                target="_blank">
                <i class="fab fa-facebook-square"></i>
                <p class="hidden-lg">Facebook</p>
                <md-tooltip md-direction="bottom">Like us on Facebook</md-tooltip>
              </md-list-item>
              <!-- <md-list-item
                href="https://www.instagram.com/CreativeTimOfficial"
                target="_blank">
                <i class="fab fa-instagram"></i>
                <p class="hidden-lg">Instagram</p>
                <md-tooltip md-direction="bottom">Follow us on Instagram</md-tooltip>
              </md-list-item> -->
              <!-- <md-list-item
                href="http://tw.yahoo.com"
                target="_blank">
                <i class="fa fa-user-circle"></i>
                <p class="hidden-lg">Sign In</p>
                <md-tooltip md-direction="bottom">Sign In</md-tooltip>
              </md-list-item> -->

              <md-list-item v-if="!isSignedIn"
                @click="signIn()">
                
                <i class="material-icons">person_outline</i>
                <!-- <i class="material-icons">account_box</i> -->
                <!-- <i class="fa fa-user-circle"></i> -->
                <p>Sign In</p>
              </md-list-item>

              <!-- <md-list-item v-if="isSignedIn"
                @click="signOut()">
                
                <i class="material-icons">person_outline</i>
                <p>Logout</p>
              </md-list-item> -->

              <li class="md-list-item" v-if="isSignedIn" style="margin-left: 6px;">
                <a
                  href="javascript:void(0)"
                  class="md-list-item-router md-list-item-container md-button-clean dropdown"
                >
                  <div class="md-list-item-content">
                    <drop-down direction="down" class="profile-photo">
                      <div
                        class="profile-photo-small"
                        slot="title"
                        data-toggle="dropdown"
                      >
                        <img :src="userProfileImageUrl" alt="Circle Image" />
                      </div>
                      
                      <ul class="dropdown-menu dropdown-menu-right">
                        <li class="dropdown-header">User menu</li>
                        <li>
                          <a href="#pablo" class="dropdown-item">Me</a>
                        </li>
                        <li>
                          <a href="#pablo" class="dropdown-item"
                            >Settings and other stuff</a
                          >
                        </li>
                        <li>
                          <a class="dropdown-item" @click="signOut()"
                            >Sign Out</a
                          >
                        </li>
                      </ul>
                    </drop-down>
                  </div>
                </a>
              </li>

            </md-list>
          </div>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
let resizeTimeout;
function resizeThrottler(actualResizeHandler) {
  // ignore resize events as long as an actualResizeHandler execution is in the queue
  if (!resizeTimeout) {
    resizeTimeout = setTimeout(() => {
      resizeTimeout = null;
      actualResizeHandler();

      // The actualResizeHandler will execute at a rate of 15fps
    }, 66);
  }
}

import Vue from "vue"
import App from "../App.vue"
import MobileMenu from "@/layout/MobileMenu"
const jwt = require('jsonwebtoken')
const axios = require('axios').default

export default {
  components: {
    MobileMenu
  },
  props: {
    type: {
      type: String,
      default: "white",
      validator(value) {
        return [
          "white",
          "default",
          "primary",
          "danger",
          "success",
          "warning",
          "info"
        ].includes(value);
      }
    },
    colorOnScroll: {
      type: Number,
      default: 0
    },
    hide: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      extraNavClasses: "",
      toggledClass: false
    };
  },
  computed: {
    showDownload() {
      const excludedRoutes = ["login", "landing", "profile"];
      return excludedRoutes.every(r => r !== this.$route.name);
    },
    isSignedIn() {
      let refreshToken = this.$store.state.refreshToken
      let accessToken = this.$store.state.accessToken

      if (!refreshToken || !accessToken) {
        return false
      }

      return true
    },
    userProfileImageUrl() {
      let user = this.$store.state.user
      if (this.isEmptyObject(user)) {
        return require("@/assets/img/faces/avatar.jpg")
      } else {
        return user.imageUrl
      }
    }
  },
  methods: {
    isEmptyObject(obj) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          return false;
        }
      }
      return true;
    },
    bodyClick() {
      let bodyClick = document.getElementById("bodyClick");

      if (bodyClick === null) {
        let body = document.querySelector("body");
        let elem = document.createElement("div");
        elem.setAttribute("id", "bodyClick");
        body.appendChild(elem);

        let bodyClick = document.getElementById("bodyClick");
        bodyClick.addEventListener("click", this.toggleNavbarMobile);
      } else {
        bodyClick.remove();
      }
    },
    toggleNavbarMobile() {
      this.NavbarStore.showNavbar = !this.NavbarStore.showNavbar;
      this.toggledClass = !this.toggledClass;
      this.bodyClick();
    },
    handleScroll() {
      let scrollValue =
        document.body.scrollTop || document.documentElement.scrollTop;
      let navbarColor = document.getElementById("toolbar");
      this.currentScrollValue = scrollValue;

      if (!this.hide) {
        if (this.colorOnScroll > 0 && scrollValue > this.colorOnScroll) {
          this.extraNavClasses = `md-${this.type}`;
          navbarColor.classList.remove("md-transparent");
        } else {
          if (this.extraNavClasses) {
            this.extraNavClasses = "";
            navbarColor.classList.add("md-transparent");
          }
        }
      }
    },
    scrollListener() {
      resizeThrottler(this.handleScroll);
    },
    scrollToElement() {
      let element_id = document.getElementById("downloadSection");
      if (element_id) {
        element_id.scrollIntoView({ block: "end", behavior: "smooth" });
      }
    },
    generateLineLoginUrl() {
      axios({
        method: 'get',
        url: Vue.Constants.BADMINTON_API_URL + 'auth/nonces/'
      }).then(function (response) {
        if (!response.data) {
          Vue.notify({
            group: Vue.Constants.NOTIF_GROUP_COMMON,
            type: 'error',
            title: Vue.Constants.TEXT_NOTIFICATION_ERROR,
            text: '無法取得隨機碼',
            duration: Vue.Constants.NOTIF_DURATION_INFINITE,
            speed: Vue.Constants.NOTIF_SPEED_DEFAULT
          })
          return
        }

        if (response.data.status != 0) {
          Vue.notify({
            group: Vue.Constants.NOTIF_GROUP_COMMON,
            type: 'error',
            title: Vue.Constants.TEXT_NOTIFICATION_ERROR,
            text: response.data.msg,
            duration: Vue.Constants.NOTIF_DURATION_INFINITE,
            speed: Vue.Constants.NOTIF_SPEED_DEFAULT
          })
          return
        }
      })
    },
    randomText(length) {
      var result           = ''
      var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      var charactersLength = characters.length
      for ( var i = 0; i < length; i++ ) {
          result += characters.charAt(Math.floor(Math.random() * charactersLength))
      }
      return result
    },
    signIn() {
      let vm = this
      axios({
        method: 'get',
        url: Vue.Constants.BADMINTON_API_URL + 'auth/nonces/'
      }).then(function (response) {
        if (!response.data) {
          vm.showNotificationError('無法取得隨機碼')
          return
        }

        if (response.data.status != 0) {
          vm.showNotificationError(response.data.msg)
          return
        }

        let nonce = response.data.data.nonce
        // vm.showNotificationSuccess(nonce)

        let nonceString = JSON.stringify(nonce)

        let state = vm.randomText(5)
        localStorage.setItem(Vue.Constants.KEY_LS_LINE_STATE, state)
        localStorage.setItem(Vue.Constants.KEY_LS_LINE_NONCE, JSON.stringify(nonce))
        let lineLoginUrl = 'https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=' + Vue.Constants.LINE_CLIENT_ID + '&redirect_uri=' + encodeURIComponent(Vue.Constants.LINE_REDIRECT_URL) + '&state=' + state + '&scope=' + encodeURIComponent(Vue.Constants.LINE_SCOPE) + '&nonce=' + nonce.value
        window.location.href = lineLoginUrl
      })
    },
    signOut() {
      let headers = {}
      headers[Vue.Constants.BADMINTON_API_HEADER_AUTH] = 'Bearer ' + this.$store.state.accessToken
      headers[Vue.Constants.BADMINTON_API_HEADER_ID_TYPE] = Vue.Constants.ID_TYPE_LINE
      const params = new URLSearchParams()
      axios.post(Vue.Constants.BADMINTON_API_URL + 'users/logout', params, {headers: headers}).then(function (response) {
      }).catch(function (error) {
      })

      this.$store.commit('clearUserData')
      if (this.$route.name != 'all' && this.$route.name != 'index') {
        this.$router.push({ name: 'index' })
      }
    }
  },
  mounted() {
    document.addEventListener("scroll", this.scrollListener)
    // setTimeout(() => this.isSignedIn(), 500)

    // let user = this.$store.state.user
    // if (this.isSignedIn && this.isEmptyObject(user)) {
    //   let vm = this
    //   let headers = {}
    //   headers[Vue.Constants.BADMINTON_API_HEADER_AUTH] = 'Bearer ' + this.$store.state.accessToken
    //   headers[Vue.Constants.BADMINTON_API_HEADER_ID_TYPE] = Vue.Constants.ID_TYPE_LINE
    //   axios.get(Vue.Constants.BADMINTON_API_URL + 'users/profile', {headers: headers}).then(function (response) {

    //     vm.$store.commit('setUser', response.data.data.user)
    //   }).catch(function (error) {
    //     if (error.response.status) {
    //       // refresh access token
    //       const params = new URLSearchParams()
    //       params.append('grant_type', 'refresh_token')
    //       params.append('refresh_token', vm.$store.state.refreshToken)
    //       params.append('client_id', Vue.Constants.LINE_CLIENT_ID)
    //       params.append('client_secret', Vue.Constants.LINE_SECRET)
    //       axios.post('https://api.line.me/oauth2/v2.1/token', params, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then(function (response) {

    //         let accessToken = response.data.access_token
    //         let refreshToken = response.data.refresh_token

    //         vm.$store.commit('setRefreshToken', refreshToken)
    //         vm.$store.commit('setAccessToken', accessToken)

    //         let headers = {}
    //         headers[Vue.Constants.BADMINTON_API_HEADER_AUTH] = 'Bearer ' + accessToken
    //         headers[Vue.Constants.BADMINTON_API_HEADER_ID_TYPE] = Vue.Constants.ID_TYPE_LINE
    //         axios.get(Vue.Constants.BADMINTON_API_URL + 'users/profile', {headers: headers}).then(function (response) {

    //           vm.$store.commit('setUser', response.data.data.user)
    //         }).catch(function (error) {
    //         })
    //       }).catch(function (error) {
    //       })
    //     }
    //   })
    // }
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.scrollListener)
  }
};
</script>
